import { createBrowserRouter, RouteObject } from "react-router";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import IssuesPage from "./pages/Issues";
import AttackForgeIssuesPage from "./pages/AttackForgeIssues";
import SnykIssuesPage from "./pages/SnykIssues";

const Routes: Array<RouteObject> = [
  {
    path: '',
    Component: Home
  },
  {
    path: 'issues/:id',
    Component: IssuesPage
  },
  {
    path: 'issues/af/:id',
    Component: AttackForgeIssuesPage
  },
  {
    path: 'issues/snyk/code/:id',
    Component: SnykIssuesPage
  },
  {
    path: 'issues/snyk/source/:id',
    Component: SnykIssuesPage
  }


];

const Router = createBrowserRouter([
  {
    path: '/',
    Component: Layout,
    children: Routes,
  },
]);

export default Router;
